import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=ec4c1848&scoped=true"
import script from "./Tabela.vue?vue&type=script&lang=js"
export * from "./Tabela.vue?vue&type=script&lang=js"
import style0 from "./Tabela.vue?vue&type=style&index=0&id=ec4c1848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4c1848",
  null
  
)

export default component.exports